import React from 'react'
import Withdrawal from './components/Withdrawal'

const CryptoWithdraw = () => <Withdrawal />

export default React.memo(CryptoWithdraw)
